var TorsoListView = require('backbone-torso/modules/ListView');
var AppointmentDataBehavior = require('./AppointmentDataBehavior');
var AppointmentInstructionItemView = require('./AppointmentInstructionItemView');
var appointmentInstructionListWidgetTemplate = require('./appointmentInstructionListWidgetTemplate.hbs');

/**
 * This view renders an List of Appointment Instructions
 * @class AppointmentInstructionListWidget
 * @constructor
 * @param options {Object} Options to configure this view.
 *   @param [options.appointmentExternalIds] {List} the ids of the appointments being preregistered for
 * @extends Torso.ListView
 */
module.exports = TorsoListView.extend({
  tagName: 'ol',
  className: 'brec-list brec-list__full',
  itemView: AppointmentInstructionItemView,
  template: appointmentInstructionListWidgetTemplate,
  itemContainer: 'instruction-items',

  behaviors: {
    appointments: {
      behavior: AppointmentDataBehavior,
      renderOnFetch: true,
      alwaysFetch: true,
      id: { property: '_appointmentExternalIds' }
    }
  },

  /**
   * @method initialize
   * @param options {Object} Options to configure this view.
   *   @param [options.patientVecnaId} {String} the vecnaId of the patient
   *   @param [options.appointmentExternalIds] {List} the ids of the appointments being preregistered for
   *   @param [options.barcodeState] {Torso.Cell} the barcode state
   * @override
   */
  initialize: function(options) {
    this._appointmentExternalIds = options.appointmentExternalIds;
    this._patientVecnaId = options.patientVecnaId;
    this._barcodeState = options.barcodeState;

    var appointmentsDataBehavior = this.getBehavior('appointments');
    this.collection = appointmentsDataBehavior.data.privateCollection;

    this.__itemContext = {
      patientVecnaId: options.patientVecnaId,
      barcodeState: options.barcodeState
    };
  }
});
